<template>
  <div @click="pickerShow = false">
    <div class="list_content">
      <div class="search_top">
        <div>
          <div>
            <span>出发城市</span>
            <df-selectCity
              @selectCity="changeSelectCity($event)"
              @click="isFrom = true"
              :cityNameInfo="searchFrom.from"
              :disabled="endorse == 1"
              class="city_chose"
            ></df-selectCity>
          </div>
          <div>
            <img src="@assets/img/change.png" class="exchange_img" @click="exchange" />
          </div>
          <div>
            <span>到达城市</span>
            <df-selectCity
              @selectCity="changeSelectCity($event)"
              @click="isFrom = false"
              :cityNameInfo="searchFrom.to"
              :disabled="endorse == 1"
              class="city_chose"
            ></df-selectCity>
          </div>

          <div class="date">
            <span>出发时间</span>
            <a-date-picker
              style="width:280px;"
              class="picker"
              size="large"
              v-model:value="searchData"
              :disabled-date="disabledDate"
              @change="confirmDate(searchData)"
              valueFormat="YYYY/MM/DD"
            >
              <template #suffixIcon
                ><span style="color:rgba(0, 0, 0, 0.65)">{{ weekDate }}</span></template
              >
            </a-date-picker>
          </div>
        </div>
        <div>
          <a-button type="primary" class="searchBtn" @click="searchSubmit">搜索列车</a-button>
        </div>
      </div>

      <div class="search_title">
        <div class="station">
          <span>{{ fromStation }}</span>
          <span><img src="@assets/img/cardline.png"/></span>
          <span>{{ toStation }}</span>
          <span class="totle_tips"> {{ choseDate }} （共{{ list.length }}车次） </span>
        </div>
        <div @click.stop="pickerShow = true" class="datePickerShow_ct">
          <a-date-picker
            v-model:value="choseDate"
            class="datePickerShow"
            valueFormat="YYYY/MM/DD"
            :open="pickerShow"
            @change="pickerChange"
            :disabled-date="disabledDate"
          />
          <img src="@assets/img/calendar2.png" />
          <!-- <InsertRowAboveOutlined :style='{fontSize:"30px"}' class='icon'/> -->
        </div>
      </div>
      <df-selectDate :date="choseDate"></df-selectDate>
      <div class="filter" :class="{ readmore: moreTag }">
        <div v-show="trainClasses.length">
          <span>车次类型:</span>
          <a-checkbox-group v-model:value="trainClassesCheckedList" :options="trainClasses" @change="changeFilter" />
        </div>
        <div v-show="seatNames.length">
          <span>坐席类型:</span>
          <a-checkbox-group v-model:value="seatNamesCheckedList" :options="seatNames" @change="changeFilter" />
        </div>
        <div v-show="fromStations.length">
          <span>出发车站:</span>
          <a-checkbox-group v-model:value="fromStationsCheckedList" :options="fromStations" @change="changeFilter" />
        </div>
        <div v-show="fromStations.length">
          <span>到达车站:</span>
          <a-checkbox-group v-model:value="toStationsCheckedList" :options="toStations" @change="changeFilter" />
        </div>
        <span class="clear_filter" @click="clearFilter">清空条件</span>
        <span class="more_filter" @click="changeMoreTag">{{ moreTag ? "收起" : "更多选项" }}</span>
      </div>

      <div class="list">
        <a-row class="list_title" type="flex" justify="center" align="top">
          <a-col :span="4" class="tiitem">车次信息</a-col>
          <a-col :span="3" class="tiitem hasfilter" @click="sortAction(1)">
            出发站/时间
            <span>
              <ArrowUpOutlined :style="{ color: '#999' }" v-show="sortTag != 1 && sortTag != 2" />
              <ArrowUpOutlined :style="{ color: '#3999FB' }" v-show="sortTag == 1" />
              <ArrowDownOutlined :style="{ color: '#3999FB' }" v-show="sortTag == 2" />
            </span>
          </a-col>
          <a-col :span="3" class="tiitem hasfilter" @click="sortAction(2)"
            >运行时长
            <span>
              <ArrowUpOutlined :style="{ color: '#999' }" v-show="sortTag != 3 && sortTag != 4" />
              <ArrowUpOutlined :style="{ color: '#3999FB' }" v-show="sortTag == 3" />
              <ArrowDownOutlined :style="{ color: '#3999FB' }" v-show="sortTag == 4" />
            </span>
          </a-col>
          <a-col :span="3" class="tiitem"
            >到达站/时间
            <!-- @click='sortAction(3)' -->
            <!-- <span>
                            <ArrowUpOutlined :style='{color:"#999"}' v-show='sortTag != 5 && sortTag != 6'/>
                            <ArrowUpOutlined :style='{color:"#3999FB"}' v-show='sortTag == 5'/>
                            <ArrowDownOutlined :style='{color:"#3999FB"}' v-show='sortTag == 6'/>
                        </span> -->
          </a-col>
          <a-col :span="4" class="tiitem">坐席/参考价</a-col>
          <a-col :span="3" class="tiitem">余票</a-col>
          <a-col :span="4" class="tiitem">
            <a-checkbox v-model:checked="checkedall" @change="changeFilter">
              只显示有票车次
            </a-checkbox>
          </a-col>
        </a-row>
        <a-spin :spinning="spinning" tip="努力搜票中......">
          <div style="margin-bottom:50px;min-height:200px">
            <df-listItem
              v-for="(item, index) in list"
              :key="index"
              :item="item"
              :fromStation="fromStation"
              :toStation="toStation"
              :choseDate="choseDate"
              :endorse="endorse"
              @stopShow="stopShow"
              @close="closestopShow"
            ></df-listItem>
            <a-skeleton active :loading="spinning" />
            <a-skeleton active :loading="spinning" />
            <a-skeleton active :loading="spinning" />
            <a-empty :description="'～没有指定车次～'" v-show="!list.length && !spinning" style="margin-top:50px" />
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, watch, provide } from "vue";
import { FallOutlined, InsertRowAboveOutlined, ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons-vue";
import homeApi from "@axios/home";
import { filterHighRailway, filterHasRailway, filterCompreRailway } from "@assets/js/listFilter";
import { useRoute } from "vue-router";

const plainOptions = ["Apple", "Pear", "Orange"];
export default {
  name: "list",
  components: {
    FallOutlined,
    InsertRowAboveOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined
  },
  setup() {
    let choseDate = ref("2020-11-11");
    let fromStation = ref("北京");
    let toStation = ref("沈阳");
    let isHigh = 0;
    let isHighCont = 0;

    let isFrom = ref(true);

    const route = useRoute();

    choseDate.value = route.query.fromDate;
    fromStation.value = route.query.fromCity;
    toStation.value = route.query.toCity;
    isHigh = parseInt(route.query.isHigh);

    let searchFrom = ref({
      from: "",
      to: ""
    });

    let searchData = ref("");

    searchFrom.value.from = route.query.fromCity;
    searchFrom.value.to = route.query.toCity;
    searchData.value = route.query.fromDate.split("-").join("/");

    let spinning = ref(false);

    const changeDate = (val) => {
      choseDate.value = val;
      //返璞归真
      trainClassesCheckedList.value = [];
      seatNamesCheckedList.value = [];
      fromStationsCheckedList.value = [];
      toStationsCheckedList.value = [];
      sortTag.value = 1;
      checkedall.value = false;
      getTrainsList();
    };

    let checkedall = ref(false);
    let moreTag = ref(false);
    const changeMoreTag = () => {
      moreTag.value = !moreTag.value;
    };

    let original = []; //原数据 筛选时候用到
    let list = ref([
      //展示数据
    ]);

    let trainClasses = ref([]); //车次类型
    let seatNames = ref([]); //坐席类型
    let fromStations = ref([]); //出发车站
    let toStations = ref([]); //到达车站

    let trainClassesCheckedList = ref([]);
    let seatNamesCheckedList = ref([]);
    let fromStationsCheckedList = ref([]);
    let toStationsCheckedList = ref([]);
    let sortTag = ref(1);

    // 0不排序  接口默认
    // 1出发时间正续  接口默认
    // 2出发时间倒序
    // 3运行时长正序
    // 4运行时长倒序
    // 5到达时间正序
    // 6到达时间倒序

    const getTrainsList = () => {
      let params = {
        fromStation: fromStation.value,
        toStation: toStation.value,
        date: choseDate.value
      };
      list.value = [];
      spinning.value = true;
      homeApi
        .getTrainsList(params)
        .then((res) => {
          list.value = res.trains;

          original = res.trains;

          trainClasses.value = res.trainClasses;
          seatNames.value = res.seatNames;
          fromStations.value = res.fromStations;
          toStations.value = res.toStations;
          if (isHigh && !isHighCont) {
            isHighCont++;
            if (trainClasses.value.indexOf("高速动车组") == -1) {
              trainClasses.value.push("高速动车组");
            }
            if (trainClasses.value.indexOf("动车组") == -1) {
              trainClasses.value.push("动车组");
            }
            trainClassesCheckedList.value = ["高速动车组", "动车组"];
            changeFilter();
          }

          spinning.value = false;
        })
        .catch((e) => {
          original = [];
          spinning.value = false;
        });
    };

    getTrainsList();

    const changeFilter = () => {
      //综合多条件筛选
      let params = {
        trainClasses: trainClassesCheckedList.value,
        seatNames: seatNamesCheckedList.value,
        stations: fromStationsCheckedList.value.concat(toStationsCheckedList.value)
      };
      list.value = filterCompreRailway(original, params, checkedall.value, sortTag.value);
    };

    const clearFilter = () => {
      trainClassesCheckedList.value = [];
      seatNamesCheckedList.value = [];
      fromStationsCheckedList.value = [];
      toStationsCheckedList.value = [];
      changeFilter();
    };

    const sortAction = (num) => {
      if (num == 1) {
        if (sortTag.value == 1) {
          sortTag.value = 2;
        } else {
          sortTag.value = 1;
        }
      }
      if (num == 2) {
        if (sortTag.value == 3) {
          sortTag.value = 4;
        } else {
          sortTag.value = 3;
        }
      }
      if (num == 3) {
        if (sortTag.value == 5) {
          sortTag.value = 6;
        } else {
          sortTag.value = 5;
        }
      }
      changeFilter();
    };

    let pickerShow = ref(false);

    const pickerChange = (data) => {
      console.log(data);

      pickerShow.value = false;
      trainClassesCheckedList.value = [];
      seatNamesCheckedList.value = [];
      fromStationsCheckedList.value = [];
      toStationsCheckedList.value = [];
      sortTag.value = 1;
      checkedall.value = false;
      getTrainsList();
    };

    const disabledDate = (current) => {
      return current < moment().add(-1, "d") || current > moment().add(30, "d");
    };

    const changeSelectCity = (data) => {
      // console.log(data)
      if (isFrom.value) {
        searchFrom.value.from = data;
      } else {
        searchFrom.value.to = data;
      }
    };

    let weekDate = ref("");
    let confirmDate = (date, dateString) => {
      let tmpnewchar = "";
      if (date) {
        switch (new Date(date).getDay()) {
          case 0:
            tmpnewchar = "星期日";
            break;
          case 1:
            tmpnewchar = "星期一";
            break;
          case 2:
            tmpnewchar = "星期二";
            break;
          case 3:
            tmpnewchar = "星期三";
            break;
          case 4:
            tmpnewchar = "星期四";
            break;
          case 5:
            tmpnewchar = "星期五";
            break;
          case 6:
            tmpnewchar = "星期六";
            break;
        }
      }
      weekDate.value = tmpnewchar;
    };

    const searchSubmit = () => {
      fromStation.value = searchFrom.value.from;
      toStation.value = searchFrom.value.to;
      changeDate(searchData.value);
    };

    const exchange = () => {
      let to = searchFrom.value.to;
      searchFrom.value.to = searchFrom.value.from;
      searchFrom.value.from = to;

      console.log(searchFrom.value);
    };

    provide("changeDate", changeDate);

    let endorse = ref(null);

    if (route.query.endorse) {
      endorse.value = route.query.endorse;
    } else {
      endorse.value = null;
    }

    confirmDate(searchData.value);

    const stopShow = (trainNo) => {
      list.value.forEach((element) => {
        if (element.trainNo == trainNo) {
          element.stopShow = true;
        } else {
          element.stopShow = false;
        }
      });
    };

    const closestopShow = () => {
      list.value.forEach((element) => {
        element.stopShow = false;
      });
    };

    return {
      closestopShow,
      stopShow,
      endorse,
      exchange,
      searchSubmit,
      confirmDate,
      weekDate,
      searchData,
      searchFrom,
      changeSelectCity,
      isFrom,
      disabledDate,
      pickerShow,
      pickerChange,
      clearFilter,
      sortTag,
      sortAction,
      changeFilter,
      trainClassesCheckedList,
      seatNamesCheckedList,
      fromStationsCheckedList,
      toStationsCheckedList,
      toStations,
      fromStations,
      seatNames,
      trainClasses,
      toStation,
      fromStation,
      list,
      spinning,
      checkedall,
      changeMoreTag,
      moreTag,
      choseDate,
      plainOptions
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.city_chose {
  width: 200px;
}
.exchange_img {
  width: 22px;
  position: relative;
  top: 15px;
  cursor: pointer;
}
.datePickerShow_ct {
  position: relative;
  & > img {
    position: absolute;
    height: 30px;
    width: 30px;
    cursor: pointer;
    z-index: 10;
    right: 0;
  }
}
.datePickerShow {
  width: 0.5px !important;
  height: 0.5px !important;
  position: absolute;
  right: 3px;
  top: 0;
  opacity: 0;
  z-index: 1;
}

.hasfilter {
  cursor: pointer;
  span {
    margin-left: 5px;
  }
}
.list {
  margin-top: 16px;
  .list_title {
    background: #f8f8f8;
    border: 0.5px solid #cdcccd;
    padding: 10px 0;
  }
  .tiitem {
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC;
  }
}
.list_content {
  width: 1200px;
  margin: 0 auto;
  .search_top {
    height: 110px;
    background: #fafdff;
    border: 0.5px solid #0d6dbf;
    border-top: none;
    display: flex;
    justify-content: space-between;
    padding: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-size: 16px;
    ::v-deep(.ant-select) {
      font-size: 16px;
    }
    & > div {
      display: flex;
      align-items: center;

      & > div {
        display: flex;
        flex-direction: column;
        margin-right: 15px;
        span {
          margin-bottom: 6px;
        }
      }
    }
    .date {
      margin-left: 104px;
      .picker {
        position: relative;
        top: 2px;
      }
    }
  }
}
.search_title {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  .station {
    display: flex;
    color: #0d6dbf;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 35px;
    span {
      margin-right: 18px;
    }
    img {
      width: 53px;
    }
    .totle_tips {
      position: relative;
      top: 2px;
      color: #000000;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
    }
  }
}
.searchBtn {
  width: 144px;
  height: 68px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  border-radius: 5px;
  background: #ffab00;
  border-color: #ffab00;
}
.filter {
  padding: 13px 19px;
  padding-top: 5px;
  border: 0.5px solid #cdcccd;
  border-top: none;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  position: relative;
  max-height: 100px;
  overflow: hidden;

  div {
    margin-top: 8px;
    span {
      margin-right: 13px;
    }
  }
  .clear_filter {
    position: absolute;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #787d84;
    right: 19px;
    top: 13px;
    cursor: pointer;
  }
  .more_filter {
    position: absolute;
    right: 19px;
    bottom: 13px;
    height: 21px;
    background: #ffffff;
    border: 0.5px solid #979797;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    display: flex;
    line-height: 21px;
    display: block;
    padding: 0 9px;
    cursor: pointer;
    color: #6d7278;
  }
}
.readmore {
  max-height: 300px !important;
}
</style>
